import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "sg_cookie_consent";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
    const open = () => setShow(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  const decide = (v) => { localStorage.setItem(KEY, v); setShow(false); };

  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-2.5 sm:p-4 pointer-events-none" data-testid="cookie-banner">
      <div className="pointer-events-auto max-w-2xl mx-auto bg-blue-600 rounded-2xl border border-blue-500 shadow-2xl shadow-blue-900/30 p-3.5 sm:p-5">
        <div className="flex items-start gap-2.5 sm:gap-3">
          <div className="hidden sm:grid w-9 h-9 rounded-xl bg-white/15 text-white place-items-center shrink-0"><Cookie className="w-5 h-5" /></div>
          <div className="min-w-0 w-full">
            <p className="font-display font-bold text-white text-sm sm:text-base flex items-center gap-2">
              <Cookie className="w-4 h-4 sm:hidden" /> Rispettiamo la tua privacy
            </p>
            <p className="text-xs sm:text-sm text-blue-100 mt-1 leading-relaxed line-clamp-3 sm:line-clamp-none">
              Usiamo cookie tecnici necessari al funzionamento del servizio. Con il tuo consenso possiamo usare cookie aggiuntivi. <Link to="/cookie" className="text-white font-semibold underline">Cookie Policy</Link>.
            </p>
            <div className="mt-3 sm:mt-4 flex gap-2 sm:gap-2.5">
              <button onClick={() => decide("accepted")} data-testid="cookie-accept" className="flex-1 rounded-full bg-white text-blue-700 font-semibold py-2 sm:py-2.5 text-sm hover:bg-blue-50 transition-colors">Accetta</button>
              <button onClick={() => decide("rejected")} data-testid="cookie-reject" className="flex-1 rounded-full border border-white/40 text-white font-semibold py-2 sm:py-2.5 text-sm hover:bg-white/10 transition-colors">Rifiuta</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
